import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { AppPaginationModule } from 'src/app/components/pagination/pagination.module';
import { SortV2Module } from 'src/app/components/sort-v2/sort-v2.module';
import { FooterModule } from 'src/app/components/footer/footer.module';
import { SearchCoreModule } from 'src/app/components/search-core/search-core.module';
import { SearchCoreChipDisplayModule } from 'src/app/components/search-core-chip-display/search-core-chip-display.module';
import { FilterV2Module } from 'src/app/components/filter-v2/filter-v2.module';
import { NoDataModule } from "src/app/components/no-data/no-data.module";
import { LoaderModule } from "src/app/components/loader/loader.module";
import { RequestsComponent } from './requests.component';
import { SendXrefButtonModule } from "src/app/components/send-xref-button/send-xref-button.module";
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { AvatarIconModule } from 'src/app/components/avatar-icon/avatar-icon.module';
import { ExitsComponent } from 'src/app/components/exits/exits.component';
import { ReferencesComponent } from 'src/app/components/references/references.component';
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { ReferenceModalModule } from 'src/app/components/reference-modal/reference-modal.module';
import { TooltipEllipsifyModule } from 'src/app/directives/tooltip-ellipsify/tooltip-ellipsify.module';
import { PulsesComponent } from 'src/app/components/pulses/pulses/pulses.component';
import {
  BannerModule,
  ButtonModule,
  EmptyStateModule,
  EmptyStateSearchModule,
  InputsModule,
  TagsModule,
  TooltipModule as XrefTooltipModule
} from '@xref/xref-lib';
import { PulseTooltipDirective } from 'src/app/components/pulse-tooltip/pulse-tooltip-directive/pulse-tooltip-directive.directive';
import { ChecksHelpModalComponent } from "../../components/checks-help-modal copy/checks-help-modal.component";
import {BackgroundChecksComponent} from "../../components/backgroundchecks/backgroundchecks.component";
import {EmptyStateComponent} from "../../components/backgroundchecks/empty-state/empty-state.component";
import {CardsModule} from "@xref/xref-lib";
import { NoAccessComponent } from './no-access/no-access.component';

@NgModule({
  declarations: [
    ExitsComponent,
    ReferencesComponent,
    BackgroundChecksComponent,
    PulsesComponent,
    EmptyStateComponent,
    RequestsComponent,
    PulseTooltipDirective,
    ChecksHelpModalComponent,
    NoAccessComponent
  ],
  imports: [
    RouterModule,
    SearchCoreModule,
    SearchCoreChipDisplayModule,
    SortV2Module,
    FooterModule,
    CommonModule,
    FilterV2Module,
    AppPaginationModule,
    AvatarIconModule,
    NoDataModule,
    LoaderModule,
    SendXrefButtonModule,
    TabsModule.forRoot(),
    TooltipModule.forRoot(),
    TooltipEllipsifyModule,
    BsDropdownModule.forRoot(),
    ReferenceModalModule,
    BannerModule,
    TagsModule,
    XrefTooltipModule,
    ButtonModule,
    CardsModule,
    InputsModule,
    EmptyStateSearchModule,
    EmptyStateModule
  ],
  exports: [
    RequestsComponent
  ]
})
export class RequestsModule { }
